module.exports = __webpack_public_path__ + "images/jumpstart-sticky-banner-bg.jpg";